import React from 'react';
import styled from 'styled-components';
import ItemWithImg from './ItemWithImg';
import ItemWithoutImg from './ItemWithoutImg';

export const Item = ({ name, price, options, imgUrl }) => {
    if(options){
        var txt = "";

        for(let i = 0; i < options.length; i++){
            if(i + 1 === options.length){
                txt += options[i];
            }else{
                txt += options[i] + ", "
            }
        }
    }

    const text = txt;

    var content;

    if(imgUrl !== ""){
        content = <ItemWithImg name={name} price={price} options={options} text={text} imgUrl={imgUrl} />;
    }else{
        content = <ItemWithoutImg name={name} price={price} options={options} text={text} />;
    }

  return (
    <Container>
        {content}
    </Container>
  )
}

const Container = styled.div`
    color: #fff;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-content: center;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;

    & > *{
        margin: auto;
    }
`;
